module.exports = __webpack_public_path__ + "img/motorcycles.5f3b4733.svg";